import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { PropType, computed } from 'vue'

type IImage = {
  src: string,
  filename: string,
  alt: string,
  download?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SilentBoxSingle',
  props: {
  image: {
    type: Object as PropType<IImage>
  }
},
  setup(__props) {

const props = __props



const imageData = computed(() => props.image)

return (_ctx: any,_cache: any) => {
  const _component_silent_box = _resolveComponent("silent-box")!

  return (_openBlock(), _createBlock(_component_silent_box, {
    ref: "lightBox",
    image: _unref(imageData),
    class: "rounded-md"
  }, {
    "silentbox-item": _withCtx(({ silentboxItem }) => [
      _createElementVNode("img", {
        src: silentboxItem.src,
        class: "rounded-md",
        alt: silentboxItem.alt
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["image"]))
}
}

})